import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const PageHeader = ({ eyebrow, title, subtitle }) => (
  <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-14 md:pt-20 pb-4">
    <Link
      to="/"
      className="inline-flex items-center gap-2 text-sm text-[#16241B]/60 hover:text-[#0E7A3B] transition-colors mb-8"
    >
      <ArrowLeft className="h-4 w-4" />
      Retour à l'accueil
    </Link>
    <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#0E7A3B]">
      {eyebrow}
    </p>
    <h1 className="mt-4 font-display text-5xl md:text-6xl lg:text-7xl text-[#16241B] leading-[0.98] tracking-tighter max-w-4xl">
      {title}
    </h1>
    {subtitle && (
      <p className="mt-6 text-lg text-[#16241B]/70 leading-relaxed max-w-2xl">
        {subtitle}
      </p>
    )}
  </div>
);

export const PageFooterNav = ({ prev, next }) => (
  <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 border-t border-[#EDE7D9]">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {prev ? (
        <Link
          to={prev.to}
          className="group rounded-3xl border border-[#EDE7D9] bg-white p-6 hover:-translate-y-0.5 hover:border-[#0E7A3B] transition-all"
        >
          <p className="font-utility text-[10px] uppercase tracking-widest text-[#16241B]/50 flex items-center gap-2">
            <ArrowLeft className="h-3 w-3" /> Page précédente
          </p>
          <p className="mt-2 font-display text-xl text-[#16241B] tracking-tight group-hover:text-[#0E7A3B]">
            {prev.label}
          </p>
        </Link>
      ) : (
        <div />
      )}
      {next ? (
        <Link
          to={next.to}
          className="group rounded-3xl border border-[#EDE7D9] bg-white p-6 hover:-translate-y-0.5 hover:border-[#0E7A3B] transition-all text-right md:text-right"
        >
          <p className="font-utility text-[10px] uppercase tracking-widest text-[#16241B]/50 flex items-center justify-end gap-2">
            Page suivante <ArrowRight className="h-3 w-3" />
          </p>
          <p className="mt-2 font-display text-xl text-[#16241B] tracking-tight group-hover:text-[#0E7A3B]">
            {next.label}
          </p>
        </Link>
      ) : (
        <div />
      )}
    </div>
  </div>
);

export { scrollTo };
